import type { CSSProperties } from 'react';

export type FeaturePromotionBannerAccent =
  | 'seaweed'
  | 'blue'
  | 'eggplant'
  | 'green'
  | 'indigo'
  | 'neutral'
  | 'red'
  | 'rose'
  | 'tangerine'
  | 'yellow';

export const getAccentCssVars = (accent: FeaturePromotionBannerAccent = 'seaweed'): CSSProperties => {
  return {
    '--fpb-border': `var(--fabric-color-accent-${accent}-base)`,
    '--fpb-header-bg': `var(--fabric-color-accent-${accent}-alpha-subtle)`,
    '--fpb-icon': `var(--fabric-color-accent-${accent}-base)`,
  } as CSSProperties;
};
